<template>
	<div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>基本信息</span>
			</div>
			<template>
				<el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
					<el-row :span="20">
						<el-col :span="20">
							<el-form-item label="标段名称：">
								<span>{{ projectInfo.bidSectionName || '-' }}</span>
							</el-form-item>
						</el-col>

					</el-row>
<!--					<el-row :span="20">-->
<!--						<el-col :span="12">-->
<!--							<el-form-item label="招标人：" prop="tenderAgencyName">-->
<!--								<span>{{ projectInfo.tendereeName || '-' }}</span>-->
<!--							</el-form-item>-->
<!--						</el-col>-->
<!--						<el-col :span="12">-->
<!--							<el-form-item label="招标代理：" prop="tenderAgencyPhone">-->
<!--								<span>{{ projectInfo.tenderAgencyName || '-' }}</span>-->
<!--							</el-form-item>-->
<!--						</el-col>-->
<!--					</el-row>-->
				</el-form>
			</template>

		</el-card>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>项目归档目录</span>
			</div>
			<template>
				<table class="eval_table">
					<thead>
					<tr>
						<th style="width: 500px">
							归档范围
						</th>
						<th style="width: 500px">
							支持上传类型
						</th>
						<th style="width: 700px">
							归档资料
						</th>
					</tr>
					</thead>
					<tbody  v-if="projectInfo.configs&&projectInfo.configs.length>0">
						<template >
							<tr  v-for="(item,index) in projectInfo.configs" :key="index">
								<td style="width:200px;text-align: left;padding-left: 16px;height: 42px;">
									{{ (index + 1) + '、' + item.name }}
								</td>
								<td style="width:200px">
									{{ item.fileExts }}
								</td>
								<td class="pdf" style="width:500px">
									<el-button :key="'idx'+idx" @click="showFileDetail(itm)" class="fileBtnWrapper" v-for="(itm,idx) in item.details">
										<icon-svg class="svg-icon" name="pdf"></icon-svg>
										<p :title="itm.fileName">{{ itm.fileName || '-' }}</p>
									</el-button>
								</td>
							</tr>
						</template>
					</tbody>
					<tbody v-else style="line-height: 44px; text-align: center; width: 100%;color: #909399">
					<tr>
						<td :colspan="3">
							暂无数据
						</td>
					</tr>

					</tbody>
				</table>
			</template>
		</el-card>
		<el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @opened="dialogOpen" @closed="dialogClose">
			<img :src="dialogImageUrl" alt="" @contextmenu.prevent="" class="viewImg">
		</el-dialog>
		<el-dialog :visible.sync="pdfDialogVisible" @closed="dialogClose" height="100%" width="100%">
			<iframe  :src="pdfViewer + this.pdfFilePath " @contextmenu.prevent="" frameborder="0" height="500" width="100%"></iframe>
		</el-dialog>

	</div>

</template>

<script>
export default {
	name:'tenderSummaryCatalog',
	props: {
		nodeCode: {
			type: String,
			defalut: 'GC00053'
		},
		purchaserMode: {
			type: String,
			defalut: ''
		},
		title: {
			type: String,
			defalut: ''
		},
		total: {
			type: Number,
			defalut: 0
		},
		projectInfo:{
			type:Object,
			default:()=>({})
		},


	},
	watch: {

	},
	data() {
		return {
			dialogImageUrl:'',
			imgDialogVisible:false,
			pdfFilePath:'',
			pdfViewer:'/pdf/web/viewer.html?file=',
			pdfDialogVisible:false,
			// 测试数据 git 历史版本有模拟数据
			// projectInfo: {}
			//
		}
	},
	created() {
		this.pdfViewer = process.env.VUE_APP_proxybaseurl + this.pdfViewer;
	},
	activated() {

	},
	methods: {
		showFileDetail(data){
			// 获取文件类型
			let type = data.filePath.substr(data.filePath.lastIndexOf(".")+1);
			let imgFlag = this.isAssetTypeAnImage(type);
			let pdfFlag = this.isAssetTypeAnPDF(type);
			if(pdfFlag){
        this.imgDialogVisible = false;
        this.pdfDialogVisible = true;
        this.pdfFilePath = data.filePath;
			}
			if(imgFlag){
				this.imgDialogVisible = true;
				this.pdfDialogVisible = false;
				this.dialogImageUrl = data.filePath;
			}else{
				this.docXia(data.filePath,data.fileName);
			}
		},

		isAssetTypeAnImage(ext){
			let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
			return arr.indexOf(ext.toLowerCase()) !== -1;
		},
		isAssetTypeAnPDF(ext) {
			let arr = ['pdf', 'PDF']
			return arr.indexOf(ext.toLowerCase()) !== -1;
		},

		docXia(filePath,fileName) {
			this.$httpReq({
				method: "get",
				url: `/sys/upload/downfile?filePath=${encodeURI(filePath)}`,
				responseType: "blob"
			}).then(res => {
				// let blob = new Blob([res.data],{type:'application/pdf'})
				// this.url = window.URL.createObjectURL(blob);
				let blob = new Blob([res.data]);
				if ("msSaveOrOpenBlob" in navigator) {
					window.navigator.msSaveOrOpenBlob(blob, fileName);
				} else {
					let link = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = link;
					a.style.display = "none";
					a.setAttribute("download", fileName);
					document.body.appendChild(a);
					a.click();
					// 移除元素
					document.body.removeChild(a);
					window.URL.revokeObjectURL(link);
					// this.url = window.URL.createObjectURL(blob);
				}
			});
		},

		dialogOpen() {
			this.$nextTick(() => {
				this.iframeInsert(this.$el);
			});
		},

		dialogClose() {
			this.dialogImageUrl = "";
			this.imgDialogVisible = false;
			this.pdfFilePath = "";
			this.pdfDialogVisible = false;
		},

	}


}
</script>

<style lang="less" scoped>
.eval_table {
	padding: 0;
	margin: 0;
	border: 1px solid #ebeef5;
	border-spacing: 0;
	border-collapse: collapse;
	text-align: center;
	table-layout: fixed;
	word-break: break-all;
	word-wrap: break-word;

	th {
		border: 1px solid #ebeef5;
		padding: 4px 8px;
		background-color: rgb(245, 247, 250);
		margin: 0;
		height: 44px;
		border-spacing: 0;
		border-collapse: collapse;
		color: #909399;
		font-weight: 500;
	}


	td {
		padding: 4px 8px;
		margin: 0;
		border-collapse: collapse;
		border-spacing: 0;
		border: 1px solid #ebeef5;

		p {
			margin: 0;
		}

		span {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.el-button {
			border: none;
			padding: 0;
			margin: 0;
			&:hover{
				background: transparent;
			}
		}

	}

  td.pdf{
    width: 500px;
    text-align: left;
  }

  .fileBtnWrapper.el-button{
    margin-right: 16px;
    width:120px;
    p{
      overflow: hidden;
      word-break: break-all;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }



}
</style>
